<payee-chip-dropdown
  [selected]="value"
  [placeholder]="'Email cím'"
  [(dropdownOpen)]="dropdownOpen"
  (removed)="removed()"
>
  <payee-form-field width="wide">
    <input
      payee-input
      placeholder="Email cím"
      [formControl]="formControl"
    />
  </payee-form-field>
</payee-chip-dropdown>
